// TODO move to core
import React from "react";
import { useEventListener } from "@hex-insights/core";

export function useSwipeNavigation(back: () => void, forward: () => void) {
	const touchStartX = React.useRef<number | null>(null);

	const onTouchStart = React.useCallback((event: Event) => {
		if (!isTouchEvent(event)) {
			return;
		}
		touchStartX.current = event.changedTouches[0].screenX;
	}, []);

	useEventListener(document, "touchstart", onTouchStart);

	const onTouchEnd = React.useCallback(
		(event: Event) => {
			if (!isTouchEvent(event)) {
				return;
			}

			if (touchStartX.current === null) {
				return;
			}
			const touchEndX = event.changedTouches[0].screenX;
			const delta = touchEndX - touchStartX.current;
			touchStartX.current = null;

			if (Math.abs(delta) / window.innerWidth < 0.15) {
				return;
			}

			if (delta > 0) {
				back();
			} else if (delta < 0) {
				forward();
			}
		},
		[back, forward],
	);

	useEventListener(document, "touchend", onTouchEnd);
}

function isTouchEvent(event: Event): event is TouchEvent {
	return "touches" in event;
}
